import { localizedFormat, localizedFormatter } from './localizedFormatter';

export const getHourFormat = localizedFormat(/(h|H){1,2}/, true);
export default localizedFormatter(getHourFormat);
